import { i18n } from "../../i18n/i18n";
import { CompanyStatusEnum } from "../enums/companyStatusEnim";

export const companyStatusEnumToText = (status: CompanyStatusEnum): string => {
    switch (status) {
        case CompanyStatusEnum.UnderReview:
            return i18n.t("companyStatuses.underReview");
        case CompanyStatusEnum.Verified:
            return i18n.t("companyStatuses.verified");
        default:
            throw new Error(`Unknown status: ${status}`);
    }
};

export const tinLabelByCountry = (countryCode: string): string => {
    switch (countryCode) {
        case "UA":
            return i18n.t("contactInfo.edrpou");
        default:
            return i18n.t("contactInfo.vatId");
    }
};
